<template>
  <div class="col-md-12" style="width: 100%; height: 100%">
    <info-form-modal
      :isFormModalActive="openFormModal"
      :title="
        formModalData.doc_id ? formModalTitleEditData : formModalTitleNewData
      "
      :data="formModalData"
      :columns="columns"
      @closeFormModal="toggleOpenFormModal(false)"
      @insert="onInsert"
      @update="onUpdate"
      @delete="onDelete"
      @forceLoad="loadData()"
    />
    <div
      slot="header"
      class="flex flex-wrap-reverse items-center flex-grow justify-between"
    >
      <!-- ADD NEW -->
      <div
        class="
          p-3
          mb-4
          mr-4
          rounded-lg
          cursor-pointer
          flex
          items-center
          justify-center
          text-lg
          font-medium
          text-base text-primary
          border border-solid border-primary
        "
        @click="onClickAddNew"
      >
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">{{
          formModalTitleNewData
        }}</span>
      </div>
    </div>

    <!-- Data Table -->
    <info-table :data="items" :columns="tableColumns" @dblclick="onDbClick" />
  </div>
</template>

<script>
import _ from "lodash"
import InfoFormModal from "./InfoFormModal.vue"
import InfoTable from "./InfoTable.vue"

export default {
  components: {
    InfoFormModal,
    InfoTable
  },
  data () {
    return {
      items: [],
      columns: [],

      //form
      formModalData: {},
      formModalTitleNewData: "새 데이터",
      formModalTitleEditData: "데이터 수정",
      openFormModal: false
    }
  },
  computed: {
    tableColumns () {
      return _.filter(this.columns, column => {
        return !column.custom.hidden
      })
    }
  },
  created () {
    this.columns = this.$store.state.info.infoColumnList || []
  },
  mounted () {
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true)

    this.loadData()
  },
  methods: {
    loadData () {
      // loading start
      this.$vs.loading()
      this.$store.dispatch("info/list").then(items => {
        this.items = items
        this.$vs.loading.close()
      })
    },
    toggleOpenFormModal (bol) {
      this.openFormModal = bol
    },
    onClickAddNew () {
      this.formModalData = {}
      this.toggleOpenFormModal(true)
    },
    onDbClick (item) {
      this.formModalData = item
      this.toggleOpenFormModal(true)
    },
    onInsert (record) {
      const self = this
      self.$vs.loading()

      self.$store.dispatch("info/insert", { data: record }).then(() => {
        self.$vs.loading.close()
        self.loadData()
      })
    },
    onUpdate (newRecord) {
      const self = this

      self.$vs.loading()
      const doc_id = newRecord.doc_id
      // update
      self.$store
        .dispatch("info/update", {
          doc_id,
          data: newRecord
        })
        .then(() => {
          self.loadData()
        })
    },
    onDelete (record) {
      const self = this
      self.$vs.loading()
      const doc_id = record.doc_id
      this.$store.dispatch("info/delete", { doc_id }).then(() => {
        self.$vs.loading.close()
        self.loadData()
      })
    }
  },
  beforeDestroy () {
    if (!this.wasFormModalOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false)
  }
}
</script>